import { DEFAULT_COMPETITION_QUESTION } from '@/lib/legal';

// The competition question, for players (no answer) and for checking an
// answer on the server. A competition without a question of its own (text and
// options) uses the default question.
//
// The correct answer is NOT in the question JSON: the database keeps it in
// competition_answers, which only admins and the server can read (migration
// 20261015140000). Server code passes it to isCorrectAnswer.

const DEFAULT = { ...DEFAULT_COMPETITION_QUESTION, correctAnswer: 'london' };

function own(raw) {
  let q = raw;
  if (typeof q === 'string') {
    try {
      q = JSON.parse(q);
    } catch {
      q = null;
    }
  }
  return q?.question && Array.isArray(q?.options) && q.options.length > 0 ? q : null;
}

function parse(raw) {
  return own(raw) || DEFAULT;
}

const norm = (v) => String(v ?? '').trim().toLowerCase();

/** { question, options: [{ value, label }] } with no answer in it. */
export function questionForPlayers(raw) {
  const q = parse(raw);
  return {
    question: q.question,
    options: q.options.map((o) =>
      typeof o === 'string'
        ? { value: o, label: o }
        : { value: String(o?.value ?? o?.label ?? ''), label: String(o?.label ?? o?.value ?? '') }
    ),
  };
}

/**
 * storedAnswer: competition_answers.correct_answer for this competition.
 * A competition with its own question but no stored answer can't be entered
 * (the migration resets such questions to the default, so this is a guard).
 */
export function isCorrectAnswer(raw, answer, storedAnswer) {
  const correct = own(raw) ? storedAnswer ?? own(raw).correctAnswer : DEFAULT.correctAnswer;
  return norm(answer) !== '' && norm(correct) !== '' && norm(answer) === norm(correct);
}
